import { Link, useLocation, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { endSession } from '../account/endSession';
import { useSite } from '../useSite';

function SignOutButton() {
  const { auth } = useSite();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const onClick = () => {
    setPending(true);
    void endSession(auth, 'signed-out', () => navigate({ to: '/signed-out' }));
  };
  return (
    <button type="button" className="btn" disabled={pending} onClick={onClick}>
      {pending ? 'Signing out…' : 'Sign out'}
    </button>
  );
}

/** The brand (home link) and, when signed in, "Sign out". */
export function SiteHeader() {
  const { auth } = useSite();
  const pathname = useLocation({ select: (location) => location.pathname });
  const signedIn = auth.status === 'authenticated' && pathname !== '/signed-out';
  return (
    <header className="border-b border-line">
      <div className="mx-auto flex w-full max-w-2xl flex-wrap items-center justify-between gap-3 px-4 py-3">
        <Link to="/" className="brand">
          <img
            src="/logo-shield.png"
            alt=""
            width={40}
            height={40}
            className="h-8 w-8 sm:h-10 sm:w-10"
          />
          <img
            src="/logo-wordmark.png"
            alt="Direwolf AI"
            width={137}
            height={40}
            className="h-8 w-auto sm:h-10"
          />
          {/* Room for "Sign out" on phones: the word stays in the link's name, out of sight. */}
          <span className={signedIn ? 'brand-suffix max-sm:sr-only' : 'brand-suffix'}>Account</span>
        </Link>
        {signedIn ? <SignOutButton /> : null}
      </div>
    </header>
  );
}
